import { render, staticRenderFns } from "./device.vue?vue&type=template&id=6874ffe5"
import script from "./device.vue?vue&type=script&lang=js"
export * from "./device.vue?vue&type=script&lang=js"
import style0 from "./device.vue?vue&type=style&index=0&id=6874ffe5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports